export default {
  tr: {
    note: "Notalar",
    notFoundSearch(value) {
      return '"<i>' + value + '</i>" için bir sonuç bulunamadı.';
    },
    resultNotFound: "İçerik bulunamadı.",
    info: "Detay için tıklayın...",
    subscribe: "E-BÜLTEN ABONELİĞİ",
    ready: "Hazırlanıyor",
    select_nomatching: "Eşleşme bulunamadı",
    select_length: "En az 2 karakter giriniz.",
    select_area_length: "En az bir alan doldurun",
    select: {
      list: "Eser Listesi",
      work: "Eser",
      composer: "Beste",
      lyricist: "Söz/Şiir",
      editor: "Düzenleme",
      performer: "Yorum",
      album: "Albüm",
      year: "Yıl",
      listen: "Dinle",
      note: "Notalar",
      lyrics: "Şarkı Sözü",
      result(n) {
        return `<strong>${n}</strong> kayıt bulundu`;
      },
    },
    find: "BUL",
    cleared: "TEMİZLE",
    search: "Ara...",
    resultInSearch: "Sonuçlar içerisinde ara...",
    searchTitle: "Şarkı adı ara...",
    searchlyricis: "Şarkı sözü ara...",
    listSearch: "Başlıklarda ara...",
    notFound:
      "Ulaşmaya çalıştığınız sayfa bulunamadı. Lütfen menüden gitmek istediğiniz bölümü seçiniz.",
    termOfuse: "Kullanım Koşulları",
    copyright1: "© Sezen Aksu 2007-",
    copyright2: " | Tüm Hakları Saklıdır.",
    update: "GÜNCELLEMELER",
    contact: {
      menu: "İLETİŞİM",
      fullname: "İsim Soyisim *",
      email: "E - Posta *",
      subject: "Konu *",
      message: "Mesaj *",
      send: "Gönder",
      title: "İletişim/Görüşleriniz",
      text:
        "Görüşlerinizi bizlerle paylaşmadan önce 'Sıkça Sorulan Sorular' bölümünü ziyaret etmenizi öneririz. Sizlerden gelen istek ve fikirler doğrultusunda sitemizin içeriğini geliştirebilmemiz mümkün olabilecektir. Görüşleriniz bizler için son derece değerli; paylaşmanızı diliyoruz.",
      error: "Lütfen formdaki bütün alanları doldurunuz",
      errorEmail: "Lütfen geçerli bir E-Posta adresi giriniz.",
      sendError: "Bir hata oluştu. Tekrar deneyiniz.",
      sendSuccess: "Mesajınız iletildi.",
      errorCaptcha: "Güvenlik kodunu yanlış girdiniz.",
    },
    update: "GÜNCELLEMELER",
    back: "Geri",
    home: "ANASAYFA",
    announcement: {
      menu: "DUYURULAR",
      actual: "GÜNCEL DUYURULAR",
      archive: "ARŞİV DUYURULAR",
      notFound: "Güncel duyuru bulunmamaktadır.",
    },
    sezen: "SEZEN'DEN",
    press: {
      pressTitle: "BASIN",
      pressClipping: "BASIN KUPÜRLERİ",
      foreignPress: "YABANCI BASIN KUPÜRLERİ",
      photoNovels: "FOTOROMAN",
      printedPublication: "BASILI YAYIN",
      pressName: "Yayın Adı",
      pressDate: "Yayın Tarihi",
      viewGallery: "Galeriye git",
    },
    allWorks: {
      menu: "TÜM YAPITLAR",
      discography: "Diskografi",
      biography: "Biyografi",
      albums: {
        albums: "Albümler",
        compilations: "Derleme Albümler",
        collaborations: "Konuk Olduğu Albümler",
        singles: "Single Albümler",
        singles_45rpms: "45'likler",
        soundtrack: "Dizi, Film ve Tiyatro Müzikleri",
        albumItem: {
          name: "Albüm Adı",
          producer: "Şirket",
          year: "Albüm Yılı",
          description: "Açıklama",
          song: "Eser",
          listen: "Dinle",
          access: "Albüme Erişim",
          lyrics: "Söz",
          by: "Beste",
          arranged: "Düzenleme",
        },
      },
      allSongs: {
        name: "Tüm Eserler",
        info:
          "<p>Sezen Aksu ile ilgili tüm eserlere bu sayfada arama gerçekleştirerek ulaşabilirsiniz.</p><p>Aşağıdaki kutuya, Eser Adı, Besteci, Söz Yazarı, Yorumcu, Düzenleyen kişi, Albüm Adı ve Eser'in yayınlandığı yıl bilgilerini ayrı ayrı veya birlikte seçerek arama gerçekleştirebilirsiniz.</p><p>Aşağıdaki kutuya şarkı sözlerini girerek de arama gerçekleştirebilirsiniz.</p>",
        end:
          "<p>Sitemizdeki eserlerin künye bilgileri, Musiki Eseri Sahipleri Grubu Meslek Birliği'nin (MSG) kayıtlarına dayanılarak listelenmiştir. Eserlerin yer aldığı albümlerin kartonetlerindeki bilgiler, zaman içindeki güncellemeler ve/veya kartonetin hazırlanması sırasında oluşabilen hatalar nedeniyle, farklılık gösterebilmektedir.</p>",
      },
      publication: "Kitap",
      dvd: "DVD",
      products: "Mücevher Tasarımları",
    },
    videos: "VİDEOLAR",
    videosMenu: undefined,
    photos: "FOTOĞRAFLAR",
    photosMenu: undefined,
    biography: "BİYOGRAFİ",
    events: "ETKİNLİKLER",
  },
  en: {
    note: "Notes",
    notFoundSearch(value) {
      return 'No result were forund for "<i>' + value + '</i>"';
    },
    resultNotFound: "No content found.",
    info: "Click for details...",
    subscribe: "E-NEWSLETTER SUBSCRIPTION",
    ready: "Preparing",
    select_nomatching: "No matching found",
    select_length: "Enter at least 2 characters ",
    select_area_length: "Fill at least one field",
    select: {
      list: "Work List",
      work: "Title",
      composer: "Music by",
      lyricist: "Lyrics by",
      editor: "Arranged by",
      performer: "Performed by",
      album: "Album",
      year: "Year",
      listen: "Listen",
      note: "Note",
      lyrics: "Lyrics",
      result(n) {
        return `<strong>${n}</strong> record found`;
      },
    },
    find: "SEARCH",
    cleared: "CLEAR",
    search: "Search...",
    resultInSearch: "Search in results...",
    searchTitle: "Search music title...",
    searchlyricis: "Search music lyric...",
    listSearch: "Search in titles",
    notFound: "The page you are looking for is not found.",
    termOfuse: "Term of Use",
    copyright1: "© Sezen Aksu 2007-",
    copyright2: " | All Rights Reserved.",
    update: "UPDATES",
    contact: {
      menu: "CONTACT",
      fullname: "Full name *",
      email: "Email *",
      subject: "Subject *",
      message: "Message *",
      send: "Send",
      title: "Professional Contact/Comments",
      text:
        "Your opinion is of great value to us, please provide your feedback.",
      error: "Please fill all the fields in the form",
      errorEmail: "email is not valid",
      sendError: "An error occurred. try again",
      sendSuccess: "Your comment has been sent.",
      errorCaptcha: "You entered the security account incorrectly.",
    },
    update: "UPDATES",
    back: "Back",
    home: "HOMEPAGE",
    announcement: {
      menu: "ANNOUNCEMENTS",
      actual: "NEWS & SCHEDULE",
      archive: "ARCHIVE",
      notFound: "There are no up-to-date announcements",
    },
    sezen: "FROM SEZEN",
    press: {
      pressTitle: "PRESS",
      pressClipping: "PRESS CLIPPING",
      foreignPress: "PRESS CLIPPING",
      photoNovels: "FOTOROMAN",
      printedPublication: "PRINT PUBLICATIONS",
      pressName: "Publication Name",
      pressDate: "Release Date",
      viewGallery: "go to the gallery",
    },
    allWorks: {
      menu: "WORK",
      discography: "Discography",
      biography: "Biography",
      albums: {
        albums: "Albums",
        compilations: "Compilations",
        collaborations: "Featuring",
        singles: "Singles (CDs)",
        singles_45rpms: "Singles (45 RPMs)",
        soundtrack: "TV, Movie and Theatre Soundtracks",
        albumItem: {
          name: "Album Name",
          producer: "Producer",
          year: "Album Year",
          description: "Description",
          song: "Song",
          listen: "Listen",
          access: "Access to Album",
          lyrics: "Lyrics",
          by: "Music by",
          arranged: "Arranged by",
        },
      },
      allSongs: {
        name: "All Songs",
        info:
          "<p>In this section you can query all songs of Sezen Aksu.</p><p>You can also search by entering the lyrics into the box below.</p>",
        end:
          "<p>The identification tags of songs are based on Musical Work Owners Group (MSG) data and might exhibit difference from those on the album booklets due to typing errors and/or regular updates on our website.</p>",
      },
      publication: "Publications",
      dvd: "DVD",
      products: "Jewellery & Accessories",
    },
    videos: "VIDEOS",
    videosMenu: undefined,
    photos: "PHOTOS",
    photosMenu: undefined,
    biography: "BIOGRAPHY",
    events: "EVENTS",
  },
};
